<script>
import CountDown from "@/components/2025/CountDown/CountDown.vue";
export default {
  components: { CountDown },
  props: ["poster", "video"],
  data() {
    return {
      currentPoster: require("@/assets/artworks/general-lp-bg.png"),
      currentVideo: require("@/assets/videos/Lp General.mp4"),
      medias: {
        home: {
          poster: require("@/assets/artworks/general-lp-bg.png"),
          video: require("@/assets/videos/Lp General.mp4"),
        },
        valorant: {
          poster: require("@/assets/artworks/valorant-lp-bg.png"),
          video: require("@/assets/videos/Lp Game Valorant.mp4"),
        },
        "street-fighter": {
          poster: require("@/assets/artworks/streetfighter-lp-bg.png"),
          video: require("@/assets/videos/Lp Game Streetfighter.mp4"),
        },
        "free-fire": {
          poster: require("@/assets/artworks/freefire-lp-bg.png"),
          video: require("@/assets/videos/Lp Game Freefire.mp4"),
        },
        eafc25: {
          poster: require("@/assets/artworks/ea-fc-lp-bg.png"),
          video: require("@/assets/videos/Lp Game Eafc.mp4"),
        },
      },
      media_for_mobile: {
        home: {
          poster: require("@/assets/artworks/general-lp-mb-bg.png"),
          video: require("@/assets/videos/landing page mobile general -1.mp4"),
        },
        valorant: {
          poster: require("@/assets/artworks/valorant-lp-mb-bg.png"),
          video: require("@/assets/videos/landing page mobile valorant.mp4"),
        },
        "street-fighter": {
          poster: require("@/assets/artworks/streetfighter-lp-mb-bg.png"),
          video: require("@/assets/videos/landing page mobile street fighter.mp4"),
        },
        "free-fire": {
          poster: require("@/assets/artworks/freefire-lp-mb-bg.png"),
          video: require("@/assets/videos/landing page mobile free firecopy.mp4"),
        },
        eafc25: {
          poster: require("@/assets/artworks/ea-fc-lp-mb-bg.png"),
          video: require("@/assets/videos/landing page mobile ea fc 25-1.mp4"),
        },
      },
      isMobile: window.innerWidth <= 575.98,
      isTablet: window.innerWidth > 575.98 && window.innerWidth <= 991.98,
    };
  },
  watch: {
    "$route.name"(newName) {
      this.updateMediaByRoute(newName);
    },
  },
  methods: {
    updateMediaByRoute(name) {
      const { poster, video } =
        (this.isMobile ? this.media_for_mobile[name] : this.medias[name]) || {};
      this.currentPoster = "";
      this.currentVideo = "";
      this.$nextTick(() => {
        this.currentVideo = video;
        this.currentPoster = poster;
      });
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 575.98;
      this.isTablet = window.innerWidth > 575.98 && window.innerWidth <= 991.98;
      this.updateMediaByRoute(this.$route.name);
    },
  },
  created() {
    this.updateMediaByRoute(this.$route.name);
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.handleResize();
    });
  },
};
</script>
<template>
  <div class="hero-banner-wrapper mx-auto position-relative">
    <div
      class="video-wrapper w-100 h-100"
      :style="{
        backgroundImage:
          'url(' + require('@/assets/artworks/bg-black.webp') + ')',
      }"
    >
      <transition name="video-fade" mode="out-in">
        <video
          :key="currentVideo"
          class="video-player"
          autoplay
          muted
          loop
          :poster="currentPoster"
          :class="{ object: isMobile }"
          playsinline
        >
          <source :src="currentVideo" type="video/mp4" />
        </video>
      </transition>
    </div>

    <div
      class="hero-section-content-wrapper position-absolute d-flex align-items-center w-100 h-100"
    >
      <div
        class="hero-section d-flex align-items-end align-items-md-center justify-content-center justify-content-md-start container-fluid mx-lg-5 pt-lg-5 w-100"
      >
        <div class="hero-section-content pt-lg-2 mb-5 mb-md-2">
          <div>
            <div
              class="mge-container d-flex flex-column flex-md-row justify-content-between align-items-center w-100"
            >
              <div class="">
                <a
                  href="https://moroccogamingexpo.ma"
                  target="_blank"
                  class="m-0 p-0"
                >
                  <img
                    :src="require('@/assets/imgs/2025/logos/mge-2025-logo.svg')"
                    height="120px"
                    alt=""
                  />
                </a>
              </div>
              <div class="">
                <h1
                  class="tournament-title text-lg-left text-center m-0 my-2 my-md-0 ml-md-4"
                >
                  MGE ESPORT<br />Tournaments
                </h1>
              </div>
            </div>
            <div
              class="tournament-title-container text-center text-md-left my-md-2 my-lg-3"
            >
              <h6 class="tournament-date">
                {{ $t("hero_section.2025.tournamentDate") }}
              </h6>
            </div>
          </div>
          <div class="my-5">
            <CountDown></CountDown>
          </div>
          <div class="mt-5 mb-3 mb-md-0 text-center text-md-left">
            <div class="mjcc-container my-3">
              <p class="text-organized-by partnership-text text-uppercase mb-2">
                organized by
              </p>
              <a href="https://mjcc.gov.ma/fr/" target="_blank" class="m-0 p-0">
                <img
                  :src="require('@/assets/imgs/logos/ministere.svg')"
                  height="80px"
                />
              </a>
            </div>
            <div
              class="partners-container d-flex justify-content-center justify-content-md-start align-items-center flex-wrap flex-md-nowrap"
            >
              <div class="mx-2">
                <p
                  class="text-uppercase text-uppercase partnership-text text-white my-2"
                >
                  official water partner:
                </p>
                <div
                  class="d-flex align-items-center justify-content-center justify-content-md-start"
                >
                  <div>
                    <a
                      href="https://www.ainatlas.ma/"
                      target="_blank"
                      class="m-0 p-0"
                    >
                      <img
                        :src="
                          require('@/assets/imgs/2025/logos/ain-atlas-logo.png')
                        "
                        height="36px"
                        class=""
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div class="mx-2">
                <p
                  class="text-uppercase text-uppercase partnership-text text-white my-2"
                >
                  official cloud partner:
                </p>
                <div
                  class="d-flex align-items-center justify-content-center justify-content-md-start"
                >
                  <div>
                    <a
                      href="https://onecloud.ma/"
                      target="_blank"
                      class="m-0 p-0"
                    >
                      <img
                        :src="require('@/assets/imgs/2025/logos/OneCloud.png')"
                        height="36px"
                        class=""
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div class="mx-2">
                <p
                  class="text-uppercase text-uppercase partnership-text text-white my-2"
                >
                  sponsor:
                </p>
                <div
                  class="d-flex align-items-center justify-content-center justify-content-md-start"
                >
                  <div>
                    <a href="https://agx.ma/" target="_blank" class="m-0 p-0">
                      <img
                        :src="require('@/assets/imgs/2025/logos/agx-logo.svg')"
                        height="36px"
                        class=""
                      />
                    </a>
                  </div>
                </div>
              </div>

              <div class="mx-2">
                <p
                  class="text-uppercase text-uppercase partnership-text text-white my-2"
                >
                  partners:
                </p>
                <div
                  class="d-flex align-items-center justify-content-center justify-content-md-start"
                >
                  <div>
                    <a href="https://frmje.ma/" target="_blank" class="m-0 p-0">
                      <img
                        :src="require('@/assets/imgs/2025/logos/fmrje.png')"
                        height="36px"
                        class="mr-3"
                      />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://www.acdsports.org/"
                      target="_blank"
                      class="m-0 p-0"
                    >
                      <img
                        :src="require('@/assets/imgs/2025/logos/aces.png')"
                        height="36px"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.hero-banner-wrapper {
  border-radius: 8px 8px 32px 8px;
  width: calc(100% - 20px);
  height: calc(100vh - 16px);
  min-height: 700px;
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - 24px),
    calc(100% - 24px) 100%,
    0 100%
  );
  padding-top: 10px;
}
.video-wrapper {
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 8px 8px 32px 8px;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px 8px 32px 8px;
  clip-path: polygon(
    0 0,
    100% 0,
    100% calc(100% - 24px),
    calc(100% - 24px) 100%,
    0 100%
  );
  display: block;
  background-color: transparent !important;
  pointer-events: none;
}

/* Transition Animations */
.video-fade-enter-active,
.video-fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.video-fade-enter-from,
.video-fade-leave-to {
  opacity: 0;
}
.hero-section-content-wrapper {
  top: 0;
  left: 0;
  width: 100%;
}
.hero-section {
  height: calc(var(--vh, 1vh) * 100);
  margin-top: 16px;
  padding-inline: 3.75rem;
}
.tournament-title {
  color: white;
  font-family: "sqwaredbold" !important;
  text-transform: uppercase;
}
.tournament-date {
  color: white;
  font-family: "sqwaredthin" !important;
}
.mjcc-container {
}
.text-organized-by {
  color: white;
  font-family: "sqwaredregular" !important;
}
.partners-container {
}
.partnership-text {
  font-family: "sqwaredsemi_bold" !important;
  font-size: 8pt;
}
@media (max-width: 575.98px) {
  .video-wrapper {
    object-fit: fill;
  }
  .video-player {
    object-fit: fill;
  }
  .hero-section {
    padding-inline: 1.75rem;
  }
  .tournament-title {
    font-size: 2em;
  }
  .mjcc-container img {
    height: 64px;
  }
}
</style>
